// Analytics + funnel shim. dataLayer events always fire (GA4/Ads pick them up
// once tags exist). When REACT_APP_GHL_WEBHOOK_URL is set, funnel steps also
// POST to a GHL inbound webhook, stitched by a per-tab session id, so GHL can
// track exactly how far each visitor got:
//   visited → scroll_50 → scroll_90 → order_intent / contact_attempt
//   → form_start → form_submit (carries name/phone/email)

const GHL_WEBHOOK = process.env.REACT_APP_GHL_WEBHOOK_URL;

const STEP_MAP = {
  buy_click: 'order_intent',
  contact_click: 'contact_attempt',
  lead_submit: 'form_submit',
};

export function getSessionId() {
  let id = sessionStorage.getItem('ah_session');
  if (!id) {
    id =
      (crypto.randomUUID && crypto.randomUUID()) ||
      String(Date.now()) + Math.random().toString(16).slice(2);
    sessionStorage.setItem('ah_session', id);
  }
  return id;
}

export function trackEvent(name, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  const step = STEP_MAP[name];
  if (step) trackStep(step, params);
}

export function trackStep(step, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: `step_${step}`, ...params });
  if (!GHL_WEBHOOK) return;
  const payload = {
    step,
    session_id: getSessionId(),
    page: window.location.pathname,
    ts: new Date().toISOString(),
    ...params,
  };
  try {
    fetch(GHL_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
      mode: 'no-cors',
    }).catch(() => {});
  } catch (_) {
    // tracking must never break the page
  }
}
